/** @jsx jsx */
import { jsx } from '@emotion/react';

import { getShouldShowCourseraPlusMerchandisingPlacements } from 'bundles/coursera-plus/utils/subscriptionsForwardDiscoveryExperiment';
import { useCourseraPlusProductOwnerships } from 'bundles/coursera-plus/utils/withCourseraPlusProductOwnerships';
import CPlusElevateLTVPromoUnit from 'bundles/unified-seo-content-common/components/promo-unit/CPlusElevateLTVPromoUnit';
import CPlusPartnerLogosPromoUnit from 'bundles/unified-seo-content-common/components/promo-unit/CPlusPartnerLogosPromoUnit';
import CPlusPromoUnit from 'bundles/unified-seo-content-common/components/promo-unit/CPlusPromoUnit';
import { PROMO_UNIT_TYPES } from 'bundles/unified-seo-content-common/constants';
import type { PromoUnitType } from 'bundles/unified-seo-content-common/types';

const PromoUnit = ({ type }: { type?: PromoUnitType | null }) => {
  const { ownsCourseraPlus } = useCourseraPlusProductOwnerships();
  const shouldShowElevateLTVUpsell = getShouldShowCourseraPlusMerchandisingPlacements();

  if (ownsCourseraPlus) {
    return null;
  }

  if (shouldShowElevateLTVUpsell) {
    return <CPlusElevateLTVPromoUnit />;
  }

  switch (type) {
    case PROMO_UNIT_TYPES.courseraPlusPartnerLogos:
      return <CPlusPartnerLogosPromoUnit />;
    case PROMO_UNIT_TYPES.courseraPlus:
      return <CPlusPromoUnit />;
    default:
      return null;
  }
};

export default PromoUnit;
